<template>
  <MissionContainer :header-url="mission.module.config.media_url + mission.module_id + '/thumbnail'">
    <h1 style="margin-bottom: 30px">{{mission.module.config.label}}</h1>

    <div class="ContextBlockSpec">
      <p>La nutrition est un déterminant majeur de santé.</p>
      <p>Au cours de la mission précédente, nous vous avons proposé de répondre à un questionnaire qui nous a permis d'analyser vos habitudes alimentaires. Il est temps maintenant de prendre quelques bonnes résolutions pour améliorer en douceur votre alimentation au quotidien.</p>
      <p>Prêt.e à engager un nouveau défi ? c'est parti !</p>
    </div>

    <p class="ObjectiveBlockSpec">
      <b class="primary--text">Objectif : </b>
      Choisir un défi Nutrition.
    </p>

    <div class="InstructionsBlockSpec">
      Pour réaliser cette mission, vous devez :<br/>
      <ol>
        <li>Choisir un défi</li>
        <li>Regarder la vidéo</li>
        <li>VALIDER la mission</li>
      </ol>
    </div>

    <p>Une fois cette mission accomplie, la vidéo sera disponible dans votre Médiathèque</p>

    <div>
      Vos réponses au test que nous vous avons proposé dans une mission précédente, nous ont permis de déterminer vos points forts et vos points à améliorer pour lesquels nous vous présentons une sélection de défis à réaliser dans les prochains jours. Vous ne pouvez réaliser qu'un défi à la fois. Le but du programme Salutance est de vous aider à adopter au moins une bonne habitude en Activité Physique et en Nutrition. Nous vous conseillons donc de choisir en priorité un défi dans votre liste "Points à améliorer" :
    </div>
    <div style="background: #F8F8F8; border-radius: 12px; padding: 55px 25px; margin-bottom: 30px;" class="mt-5">
<!-- Points importants -------------------------------------------------------------------------------------------- -->
      <div class="Info">
        <h3>Points importants</h3>
        <b>Important :</b> Lorsque l'un des trois défis suivants figure parmi vos points à améliorer, nous vous conseillons de le réaliser en priorité :
        <ul>
          <li>Mangez plus de féculents</li>
          <li>Mangez plus de fruits & légumes</li>
          <li>Mangez plus de protéines</li>
        </ul>
      </div>
<!-- Points a ameliorer -------------------------------------------------------------------------------------------- -->
      <div >
        <h3>Points à améliorer :</h3>
        <ul v-if="pointsFailbes.length > 0">
          <li v-for="defi in pointsFailbes">{{defi}}</li>
        </ul>
        <div v-else>
          Vous n'avez pas de point à améliorer. Cependant, vous pouvez sélectionner un défi dans la liste de vos points forts pour renforcer vos acquis.
        </div>
      </div>
<!-- Points forts -------------------------------------------------------------------------------------------- -->
      <div class="my-4">
        <h3>Points forts :</h3>
        <ul v-if="pointsForts.length > 0">
          <li v-for="defi in pointsForts">{{defi}}</li>
        </ul>
        <div v-else>
          Vous n'avez pas de point fort à ce jour. C'est le bon moment pour choisir un défi dans la liste des points à améliorer et acquérir au moins une bonne habitude !
        </div>
      </div>

      <div class="my-4">
        <h3>Défis réussis :</h3>
        <ul v-if="mission.module.config.defi_done.length > 0">
          Bravo ! À ce jour vous avez réussi au moins une fois les défis suivants :
          <li v-for="defi in mission.module.config.defi_done">{{mission.module.config.defi_id2name[defi]}}</li>
        </ul>
        <div v-else>
          Vous n'avez pas réussi de défi à ce jour. Choisissez-en un, en priorité dans la liste de vos points à améliorer pour acquérir au moins une bonne habitude.
        </div>
      </div>

      <p>
        <b>À noter : </b>Réussir un défi est une étape essentielle, car elle vous aide à changer de comportement. Pour en faire une bonne habitude, vous devez réussir ces défis régulièrement. Pour vous y aider, nous vous donnons la possibilité de refaire tous les défis Salutance autant de fois que vous le jugez nécessaire, soit en répondant à cette mission, soit directement à partir du catalogue des parcours dans votre Profil Utilisateur.
      </p>

      <div>
        <h3>Sélectionnez votre défi :</h3>
        <v-radio-group v-model="missionData.quiz.defi">
          <v-radio :value="0" label="Manger plus de féculents"></v-radio>
          <v-radio :value="1" label="Manger plus de fruits & légumes"></v-radio>
          <v-radio :value="2" label="Manger plus de protéines"></v-radio>
          <v-radio :value="3" label="Manger plus régulièrement"></v-radio>
          <v-radio :value="4" label="Manger plus de légumes secs"></v-radio>
          <v-radio :value="5" label="Manger plus de produits laitiers"></v-radio>
          <v-radio :value="6" label="Manger moins de produits gras et salés"></v-radio>
          <v-radio :value="7" label="Manger moins de produits sucrés"></v-radio>
          <v-radio :value="8" label="Consommer moins d'alcool"></v-radio>
          <v-radio :value="9" label="Je ne souhaite plus faire de défis" v-if="mission.module.config.defis['nutri_done']"></v-radio>
        </v-radio-group>
      </div>

      <IriadeApplicationMediaBlock v-if="missionData.quiz.defi === 0" :block="{ config: mission.module.config.block_media_feculent }"></IriadeApplicationMediaBlock>
      <IriadeApplicationMediaBlock v-if="missionData.quiz.defi === 1" :block="{ config: mission.module.config.block_media_fruit }"></IriadeApplicationMediaBlock>
      <IriadeApplicationMediaBlock v-if="missionData.quiz.defi === 2" :block="{ config: mission.module.config.block_media_proteine }"></IriadeApplicationMediaBlock>
      <IriadeApplicationMediaBlock v-if="missionData.quiz.defi === 3" :block="{ config: mission.module.config.block_media_repas }"></IriadeApplicationMediaBlock>
      <IriadeApplicationMediaBlock v-if="missionData.quiz.defi === 4" :block="{ config: mission.module.config.block_media_sec }"></IriadeApplicationMediaBlock>
      <IriadeApplicationMediaBlock v-if="missionData.quiz.defi === 5" :block="{ config: mission.module.config.block_media_laitier }"></IriadeApplicationMediaBlock>
      <IriadeApplicationMediaBlock v-if="missionData.quiz.defi === 6" :block="{ config: mission.module.config.block_media_gras }"></IriadeApplicationMediaBlock>
      <IriadeApplicationMediaBlock v-if="missionData.quiz.defi === 7" :block="{ config: mission.module.config.block_media_sucre }"></IriadeApplicationMediaBlock>
      <IriadeApplicationMediaBlock v-if="missionData.quiz.defi === 8" :block="{ config: mission.module.config.block_media_alcool }"></IriadeApplicationMediaBlock>

      <FinishMissionButtonBlock class="mt-10"
                                @click.native="finishMission">Valider la mission
      </FinishMissionButtonBlock>
    </div>
  </MissionContainer>
</template>

<script>
  import api from 'api'
  import FinishMissionButtonBlock from 'components/blocks/FinishMissionButtonBlock'
  import MissionContainer from 'components/blocks/MissionContainer'
  import IriadeApplicationMediaBlock
    from "@/components/Iriade/Blocks/IriadeApplicationMediaBlock/IriadeApplicationMediaBlock";

  export default {
    components: {
      IriadeApplicationMediaBlock,
      FinishMissionButtonBlock,
      MissionContainer
    },
    data () {
      return {
        missionData: {
          quiz: {
            defi: null,
          }
        },
      }
    },

    computed: {
      pointsFailbes() {
        let defis = this.mission.module.config.defis;
        let ret = [];

        if (defis.feculent) {
          ret.push("Manger plus de féculents")
        }

        if (defis.fruit_legume) {
          ret.push("Manger plus de fruits & légumes")
        }

        if (defis.proteine) {
          ret.push("Manger plus de protéines")
        }

        if (defis.trois_repas) {
          ret.push("Manger plus régulièrement")
        }

        if (defis.legume_sec) {
          ret.push("Manger plus de légumes secs")
        }

        if (defis.produit_laitier) {
          ret.push("Manger plus de produits laitiers")
        }

        if (defis.moins_gras_sale) {
          ret.push("Manger moins de produits gras et salés")
        }

        if (defis.moins_sucre) {
          ret.push("Manger moins de produits sucrés")
        }

        if (defis.alcool) {
          ret.push("Consommer moins d'alcool")
        }

        return ret;
      },

      pointsForts() {
        let defis = this.mission.module.config.defis;
        let ret = [];

        if (!defis.feculent) {
          ret.push("Manger plus de féculents")
        }

        if (!defis.fruit_legume) {
          ret.push("Manger plus de fruits & légumes")
        }

        if (!defis.proteine) {
          ret.push("Manger plus de protéines")
        }

        if (!defis.trois_repas) {
          ret.push("Manger plus régulièrement")
        }

        if (!defis.legume_sec) {
          ret.push("Manger plus de légumes secs")
        }

        if (!defis.produit_laitier) {
          ret.push("Manger plus de produits laitiers")
        }

        if (!defis.moins_gras_sale) {
          ret.push("Manger moins de produits gras et salés")
        }

        if (!defis.moins_sucre) {
          ret.push("Manger moins de produits sucrés")
        }

        if (!defis.alcool) {
          ret.push("Consommer moins d'alcool")
        }

        return ret;
      },
    },

    methods: {
      finishMission () {
        this.errors = {}

        api.post(`missions/${this.mission.id}`, this.missionData)
          .then(res => {
            this.$mango.snackbar({
              color: 'success',
              text: "Mission validée. Bravo !"
            })
            this.$router.push({name: 'patient@dashboard'})
          })
          .catch(err => {
            this.$mango.snackbar({
              color: 'error',
              text: "Erreur de validation. Veuillez vérifier le formulaire."
            })
          })
      },
    },

    props: {
      mission: {
        required: true,
        type: Object
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .Question {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
  }
  .Info {
    background-color: #c0c0c0;
    font-size: 19px;
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 10px
  }
  .ContextBlockSpec {
    font-size: 18px;
    font-weight: 700;
  }
  .ObjectiveBlockSpec {
    font-size: 18px;
    font-weight: 500;
  }
  .Category {
    margin-top: 25px;
  }
  .v-label {
    font-size: 20px

  }
</style>
